import React from 'react';
import MobileDetect from 'mobile-detect';
import styles from '../styles/privacy.module.scss';

function Privacy() {

    return (
        <div>
            <div className={styles.header}>
                <div className={styles.header__content}>
                    <div>
                        <span className={styles.logo}>Ham Yap</span>
                    </div>
                </div>
            </div>

            <div className={styles.frame}>
                <div className={styles.container1}>
                    <div className={styles.container1__text1}>
                        <p>MOBILE APPLICATION PRIVACY STATEMENT</p>
                    </div>
                    <div className={styles.container1__text2}>
                        <p>Release, December 07, 2023</p>
                    </div>
                </div>
               
                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p>
                            The privacy of all our Users is very important to us. When you use our Service as an App User, we (as the App Publisher) process your Personal Data. This Privacy Notice explains how we protect and process your Personal Data. We encourage you to read it carefully. 
                        </p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>
                            1. What is set out in this Privacy Notice?
                        </p>
                    </div>
                </div>
                    
                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p>- The sections in this Privacy Notice tell you about the following: </p>
                        <p>- The types of Personal Data processed, </p>
                        <p>- Purposes of processing Personal Data,  </p>
                        <p>- Places where Personal Data are processed, </p>
                        <p>- Security measures in place to protect Personal Data, </p>
                        <p>- Limits of liability in relation to third parties, </p>
                        <p>- View, modify and delete your Personal Data, </p>
                        <p>- Changes to this Privacy Notice;  </p>
                        <p>- What to do if you have questions or clarifications.  </p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>
                            2. Types of Personal Data processed
                        </p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p className={styles.containerContent__innerTitle}> 
                            A. Personal Data used by our Service
                        </p> 
                        <p> 
                            We use Anonymous Data to improve our Service. This information will not be made publicly available through the Service. 
                        </p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p className={styles.containerContent__innerTitle}> 
                            B. Automatically generated information 
                        </p> 
                        <p> 
                            Like most other websites and online services, we collect and process automatically generated information about how you use the App. Information collected includes your ip address and/or unique device ID.
                        </p>
                        <br/>
                        <p> 
                            If you specifically choose to opt-in, the App may collect your geolocation information. In any case, you can prevent the collection of your geolocation information in the settings of your mobile device.
                        </p>
                        <br/>
                        <p> 
                            If you specifically choose to authorize access and collection of information from your social network account, your basic personal information from your social network account (such as your name and email address), as well as your social network user ID (not your password) and parameters related to the posts you share through the App. Please refer to the social network's privacy policy for more information on how you can set your account's privacy preferences to control the information that can be accessed and received.
                        </p>
                        <br/>
                        <p>
                            This also happens in relation to automatically generated information about how you use the App. Such information helps us to better understand how the App is used and to produce services tailored to your needs as a user.
                        </p>
                        <br/>
                        <p>
                            If you enable user authorization features within the App, the following additional information is stored: 
                        </p>
                        <p>
                           - Name,
                        </p>
                        <p>
                           - Email,
                        </p>
                        <p>
                            - Additional profile information sent by an external provider such as Facebook, Twitter, Google+ or LinkedIn.
                        </p>
                        <br/>
                        <p>
                            We also collect the following (unknown) information to provide the app owner with information about the use of the app: 
                        </p>
                        <p>
                            - The moment you open the app,
                        </p>
                        <p>
                            - The screens you open inside the app and the time you spend on those screens.
                        </p>
                        <br/>
                        <p>
                            Note: if user authorization features are enabled, we may associate anonymous information with your information when you log in.
                        </p>
                        <p>
                            If the User wishes to save the campaign image transmitted to him/her in his/her photo album, the User's photo album and camera are accessed and the screenshot is saved in the photo album.
                        </p>
                        <br/>
                        <p>
                            The information is used only for the purpose of sending push notifications through the Application to the extent permitted by the User, securely and only for as long as necessary. The information is shared with third parties only for the realization of such purposes and the publication and disclosure of information outside this scope is not permitted.
                        </p>
                        <br/>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p className={styles.containerContent__innerTitle}> 
                            C. Specific Information 
                        </p> 
                        <p> 
                            You may be asked to apply for some activities such as loyalty cards, newsletters, advertising, in which case you will be asked for some personal information. This information is stored in the database of our service (including third parties) and will be shared with us.
                        </p>
                        <br/>
                        <p> 
                            When you upload data, including photos in the app, this will be shared and visible to all other users of the app.
                        </p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>
                            3. Purposes of processing Personal Data
                        </p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p className={styles.containerContent__innerTitle}> 
                            A. Objectives 
                        </p> 
                        <p> 
                            The Parties process Personal Data for the following purposes: 
                        </p>
                        <p>- To enable you to use the Service,</p>
                        <p>- To keep information about our service up to date,</p>
                        <p>- For service improvement and/or customization,</p>
                        <p>- To identify You and/or customize the Service,</p>
                        <p>- To recognize you and prevent fraud,</p>
                        <p>- To provide support,</p>
                        <p>- To transmit your Personal Data to third parties where you have requested us to do so or where we are legally obliged to do so.</p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p className={styles.containerContent__innerTitle}> 
                            B. Transmission of Personal Data to third parties 
                        </p> 
                        <p> 
                            We do not sell, trade or rent your Personal Data to third parties without your prior consent. However, we may provide your Personal Data to third parties where it is necessary for us to provide your Personal Data to you or for you to carry out instructions, such as to make payments through payment providers in relation to Paid Services. 
                        </p>
                        <br/>
                        <p> 
                            We may provide "aggregated anonymous data" about the use of the Service to third parties for such purposes as we deem appropriate. "Aggregated anonymous data" is data that cannot be sent back to you and is therefore not counted as Personal Data. For example, we may use aggregated anonymous data to better understand how Users use the Service.
                        </p>
                        <br/>
                        <p> 
                            In the event that we move to a third party or merge with a third party or are subject to a restructuring, your Personal Data may also be disclosed to and/or transferred to that third party. This third party will have the right to continue to use the Personal Data and any other information you provide to us. 
                        </p>
                        <br/>
                        <p> 
                            We may disclose or exercise your Personal Data where we believe in good faith that you are required to comply with a court order, pending judicial proceeding, criminal or civil subpoena, or other legal process or request issued by law enforcement authorities to defend legal rights or against legal claims. 
                        </p>
                        <br/>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>
                            4. Places where Personal Data is processed
                        </p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p> 
                            The data centers where the data processed within the scope of the Service are stored are located in different regions, Turkey, Ireland, the Netherlands, the United States of America is provided using hosting services located in the regions. However, Personal Data processed may be transferred to and stored on storage servers located in a country other than these countries and regions. We will take all steps reasonably necessary to ensure that your Personal Data is treated securely and in accordance with this privacy policy.
                        </p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>
                            5. What security measures are in place to protect Personal Data?
                        </p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p> 
                            The security of your data and the security of other Users is very important to us. We have taken technical and organizational measures to protect your Personal Data against loss or any unlawful processing. We have implemented the following measures: protecting our servers through firewalls, SSL connections and encryption of sensitive data. This list is not exhaustive. 
                        </p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>
                            6. Limits of liability in relation to third parties
                        </p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p> 
                            Our Service may contain services and products offered by third parties and/or hyperlinks to websites or services of partners, advertisers and other third parties.
                        </p>
                        <br/>
                        <p> 
                            The Parties have no control or influence over the content, websites or services of these third parties. Different privacy policies may apply to the use of third party websites and services. This Privacy Statement relates only to Personal Data obtained by the parties through your use of the Service for their own purposes. The parties disclaim any responsibility for the content, practices or operation of third party websites and services.
                        </p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>
                            7. Viewing and Deleting Personal Data
                        </p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p> 
                            You can send a request to contact us or delete personal information collected using the App via email. You may be asked to provide additional information to verify your identity.
                        </p>
                        <br/>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>
                            8. Security
                        </p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p> 
                            Measures are implemented to ensure the security of your personal information, minimize the risk of damage, loss of information and unauthorized access or use of information. However, these measures cannot provide absolute information security. Thus, efforts are made to ensure the security of your personal information, but this is not guaranteed and you cannot reasonably expect that the Application and its related databases will be immune from any wrongful conduct, malfunction, unauthorized interception or access or other misuse and abuse.
                        </p>
                        <br/>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>
                            9. Changes to this Privacy Notice
                        </p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p> 
                            This Statement may be updated at any time. The parties will post an updated version of the Privacy Statement through the Service. The parties encourage you to check this page from time to time to be aware of any changes to this Privacy Statement and to understand how the parties will protect your Personal Data. You acknowledge and agree that it is your responsibility to periodically review this Privacy Notice and stay informed of any updates.
                        </p>
                        <br/>
                        <p> 
                            You agree to be bound by any changes to this Notice. Your continued use of the App after the change becomes effective will indicate your acceptance of the amended Notice. If you do not agree to the amended Notice, you must uninstall the App and refrain from further use of it. 
                        </p>
                        <br/>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>
                            10. What if you have any questions or clarifications?
                        </p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p> 
                            If you have any questions or clarifications regarding this Privacy Statement, please contact us by sending an email. 
                        </p>
                        <br/>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text2}>
                        <p> 
                            This Privacy Notice was last updated on December 07, 2023.
                        </p>
                        <br/>
                    </div>
                </div>

            </div>
        </div>
      
    )
}

export default Privacy;